<template>
  <component
    :is="`v-${data.inputType}`"
    v-model="localValue"
    :id="data.inputType"
    :data="data"
    :label="data.label"
  />
</template>
<script>
/* eslint-disable vue/no-unused-components */
import select from "@/components/shared/dynamicForm/Select.vue";
import input from "@/components/shared/dynamicForm/Input.vue";
import date from "@/components/shared/dynamicForm/Date.vue";
import multiselect from "@/components/shared/dynamicForm/Multiselect.vue";

export default {
  components: {
    "v-select": select,
    "v-text": input,
    "v-date": date,
    "v-multiselect": multiselect
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      required: true
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    localValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.localValue = val || "";
    }
  },
  mounted() {
    this.localValue = this.value || "";
  }
};
</script>
